/**
 * Component-side wiring for createSyncReporter. The surface (card vs zoomed modal) is
 * SyncProgressProvider's call — this only feeds it the run.
 */

import { useCallback } from 'react';
import { useSyncProgress } from '../contexts/SyncProgressContext';
import {
  createSyncReporter,
  SyncReporter,
  SyncReporterOptions,
} from '../utils/syncProgressReporter';

export function useSyncReporter(): (options: SyncReporterOptions) => SyncReporter {
  const { setData } = useSyncProgress();

  return useCallback(
    (options: SyncReporterOptions) => createSyncReporter(options, { setData }),
    [setData],
  );
}
